import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: 'white',
    color: 'text.secondary',
    display: 'flex',
    justifyContent: 'center',
    zIndex: 999,
    [theme.breakpoints.down('md')]: {
      margin: '0 0 0 0',
      // width: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '0 0 0 0',
      // width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      margin: '40px 0 0 0',
      // padding: '0 0 0 -300px'
      // width: '100%',
      // borderRadius: '25px',
    }
  },
  boxContainer: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center'
  },
  boxContainerProveedor: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'right',
    alignItems: 'center'
  },
}));

export { useStyles };
